'use client';

import Link from 'next/link';
import CTAButton from '../components/ui/CTAButton';
import PhysicsSimulation from '../components/ui/PhysicsSimulation';
import HavasLogo from '../components/assets/HavasLogo';

export default function NotFound() {
  return (
    <div className="min-h-screen relative flex items-center justify-center px-6 bg-[#1a1a1a]" data-page="404">
      <PhysicsSimulation />
      
      {/* Logo in upper left */}
      <Link 
        href="/" 
        aria-label="Havas CX - Go to homepage"
        className="fixed top-6 left-6 z-20 flex items-center w-[6.25rem] text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:rounded"
      >
        <HavasLogo aria-hidden="true" />
      </Link>
      
      <div className="p-4 rounded-3xl relative z-10 max-w-2xl mx-auto text-center" style={{ backgroundColor: 'rgba(26, 26, 26, 0.92)' }}>
        <h1 className="body-xl-display mb-6 text-white">
          Well… this is awkward.
        </h1>
        <p className="body-default mb-8 text-white">
          The page you&rsquo;re looking for ghosted us.<br />We&rsquo;re as confused as you are.
        </p>
        <CTAButton href="/" className="text-white">
          Take me somewhere that does exist
        </CTAButton>
      </div>
    </div>
  );
}

